export class EvlFailedToConnectError extends Error {
    constructor(msg?: string) {
        super(msg);
        Object.setPrototypeOf(this, EvlFailedToConnectError.prototype);
    }
}
